import React, { useState } from 'react'
import { Heading, Checklist, TextField, Box, Frame } from 'components'
import { updateUser } from 'utils'
import { ProgressBarFooter } from './FreelancerProgressBarFooter'
import firebase from 'utils/firebase'
import { NUM_ONBOARDING_STEPS } from 'constants'

const FreelancerSelectCity = ({
  onboarding,
  user,
  cities,
  stepIndex,
  totalSteps,
  onSubmit = () => { },
  onNext = () => { },
}) => {
  const [state, setState] = useState({ city: null, cityId: null })

  return (
    <Frame maxWidth="xs" user={user}>
      <Box mx="auto" maxWidth={430}>
        <Heading subheading="Choosing a city implies your working area">Choose your City</Heading>

        <Checklist
          buttonLabel="Next"
          items={[...(cities?.map(city => ({ id: city.id, label: city.name })) ?? []), { id: 'other', label: 'Other' }]}
          onChange={([{ label, id }]) => {
            setState({ city: label === 'Other' ? '' : label, cityId: id })
          }}
          onSubmit={
            !onboarding
              ? ({ label, id }) => {
                updateUser(user, { city: label, cityId: id }).then(onSubmit)
                firebase
                  .analytics()
                  .logEvent('user_freelancer_city_submit_click')
              }
              : null
          }
        />

        <Box px={2} mt={-2}>
          {state.cityId === 'other' && <TextField
            label="Other City"
            required
            placeholder="Enter your city"
            value={state.city}
            onChange={(e) => setState(s => ({ ...s, city: e.target.value }))}
          />}
        </Box>
      </Box>

      {onboarding && (
        <ProgressBarFooter
          valid={state.city && state.cityId}
          stepIndex={stepIndex}
          firstStep={stepIndex}
          numSteps={totalSteps}
          onNext={() => {
            // console.log('Updating city data:', state);

            // Create cities array with the selected city
            const cityObj = {
              name: state.city,
              id: state.cityId
            };

            // Use direct Firebase update with set and merge to ensure data is saved properly
            firebase
              .firestore()
              .collection('users')
              .doc(user.id)
              .set({
                city: state.city,   // Keep original field for backward compatibility
                cityId: state.cityId, // Keep original field for backward compatibility
                cities: [cityObj]    // Add new cities array structure
              }, { merge: true })
              .then(() => {
                // console.log('City information successfully saved to database');
                onSubmit();
              })
              .catch(error => {
                console.error('Error updating city information:', error);
              });
          }}
          onPrev={() => { }}
        />
      )}
    </Frame>
  )
}

export default FreelancerSelectCity
